import * as THREE from 'three';

/**
 * The multiplier that makes a texture whose average colour is `average` come
 * out, on average, as `target` (both `#rrggbb`): a tint for "dark volcanic
 * ash" from a pale gravel photo. Worked out in linear light, as the renderer
 * multiplies, and never above 1 in any channel.
 */
export function tintFor(target: string, average: string): THREE.Color {
  const want = new THREE.Color(target);
  const have = new THREE.Color(average);
  const channel = (w: number, h: number): number => Math.min(1, w / Math.max(1e-4, h));
  return new THREE.Color(channel(want.r, have.r), channel(want.g, have.g), channel(want.b, have.b));
}
